module.exports = __webpack_public_path__ + "public/img/404-2x.c30fd2a.png";